import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { useSelector } from 'react-redux';
import { Step } from '../../types/updateApplication';

// selector
export const selectPendingSteps = createSelector(
  (state: RootState) => state.updateApplication.steps,
  (steps) => steps.filter((s) => !s.finished)
);

export const selectIsStepFinished = (stepName: Step) =>
  createSelector(
    (state: RootState) => state.updateApplication.steps,
    (steps) => steps.find((s) => s.name === stepName)?.finished ?? false
  );

export const useUpdateApplicationSelectors = () => ({
  pendingSteps: useSelector(selectPendingSteps),
  allSteps: useSelector((state: RootState) => state.updateApplication.steps),
  currentStepIndex: useSelector(
    (state: RootState) => state.updateApplication.currentStepIndex
  ),
});
